import React from "react";
class MapShenandoahNationalPark extends React.Component {
  render() {
    return (
      <React.Fragment>
        <section id="map-shenandoah-national-park" className="about-us gray-light-bg">
          <iframe
            src="https://maps.google.com/maps?saddr=Front+Royal,+VA&daddr=Dickey+Ridge+Visitor+Center,+VA+to:Skyline+Drive,+VA+to:Dark+Hollow+Falls,+VA+to:Big+Meadows,+VA+to:Old+Rag+Mountain+Trailhead,+VA+to:Loft+Mountain,+VA&output=embed"
            width="100%"
            height="420"
            title="Shenandoah National Park route map">
          </iframe>
        </section>
      </React.Fragment>
    );
  }
}
export default MapShenandoahNationalPark;
